import { apiVersion } from "../dwclient/dwcommonutils";
import { encodeSendObjectToBase58 } from "../dwclient/jwtcomm";
import { loadJwt } from "../dwclient/localstorage/jwtStorage";
import { getKeySignature } from "../dataEncryption";
import { splitPath } from "../paths";
import { syncUploadFile, abortSyncUpload } from "./syncupload";
import { myRemoveFileJwt } from "../dwclient/dwstorageutils";
/* example to use in a page:
initUploadWorker();

const arrayBuffer = new ArrayBuffer(10000000);
const f: File = new File([arrayBuffer], "foo3.txt", { type: "text/plain" });

with async functions:
await addFile(f);
await getFileList();
await removeAll();

with promise:
//addFile(f).then(() => {
//  addFile(f).then(() => {
const path = "/valami/abc/file.txt";
addFile(f, path + "2").then(() => {
  addFile(f, path).then(() => {
    getFileList().then((files) => console.log("Files in queue:", files));
  });
});
//  });
//});
removeAll().then(() => {
  getFileList().then((files) => console.log("Files in queue:", files));
});
*/
// TODO is it OK like this?
/*
let myWorker: SharedWorker | undefined = undefined;

export function initUploadWorker(onMessage?: (data: any) => void): SharedWorker {
  myWorker = new SharedWorker("/uploadWorker.js");
  console.log(myWorker);
  myWorker.port.start();
  if (onMessage) {
    myWorker.port.onmessage = onMessage;
  } else {
    myWorker.port.onmessage = function (e) {
      console.log("Received from worker:", e.data);
    };
  }
  return myWorker;
}
  */
/*export function initUploadWorker(
  onGetFiles?: (data: any) => void,
  onCompleted?: (data: any) => void,
  onProgress?: (data: any) => void,
): SharedWorker {
  myWorker = new SharedWorker("/uploadWorker.js");
  console.log(myWorker);
  myWorker.port.start();
  myWorker.port.onmessage = function (e) {
    if (e.data.status === "completed") {
      if (onCompleted) {
        onCompleted(e.data);
      } else {
        console.log("Received completed message from worker:", e.data);
      }
    } else if (e.data.status === "uploading") {
      if (onProgress) {
        onProgress(e.data);
      } else {
        console.log("Received progress message from worker:", e.data);
      }
    } else {
      // otherwise it is considered to be get file result
      if (onGetFiles) {
        onGetFiles(e.data);
      } else {
        console.log("Received getfile message from worker:", e.data);
      }
    }
  };
  return myWorker;
}*/
/*
export async function start(paramMyWorker?: SharedWorker) {
  const worker = paramMyWorker ?? myWorker;
  if (!worker) {
    return;
  }
  worker.port.postMessage({ action: "start" });
}

// Add file to upload queue
export async function addFile(
  provider: EIP1193Provider,
  file: File,
  path: string,
  onUploadProgress?: (data: any) => void,
  onCompleted?: (data: any) => void,
  onFinished?: (data: any) => void,
  paramMyWorker?: SharedWorker,
) {
  const pathParts = splitPath(path);
  if (pathParts?.name && pathParts.name.startsWith("~$")) {
    if (onFinished) {
      onFinished(undefined);
    }
    return;
  }
  const worker = paramMyWorker ?? myWorker;
  if (!worker) {
    return;
  }

  worker.port.onmessage = function (e) {
    if (e.data.status === "completed") {
      if (onCompleted) {
        onCompleted(e.data);
      } else {
        console.log("Received completed message from worker:", e.data);
      }
    } else if (e.data.status === "uploading") {
      if (onUploadProgress) {
        onUploadProgress(e.data);
      } else {
        console.log("Received progress message from worker:", e.data);
      }
    } else if (e.data.status === "finished") {
      if (onFinished) {
        onFinished(e.data);
      } else {
        console.log("Received finished message from worker:", e.data);
      }
    } else {
      console.log("Received progress message from worker:", e.data);
    }
  };
  const baseUrl = process.env.DWINITY_BACKEND ?? "https://api.dev.dwinity.com";
  const filesUrl = baseUrl + `/api/${apiVersion}/files`;
  const authToken = await loadJwt();
  const sendObject = { path };
  const message = encodeSendObjectToBase58(sendObject);
  const fileId = crypto.randomUUID();
  worker.port.postMessage({
    action: "addFile",
    filesUrl,
    fileId,
    authToken,
    file,
    message,
    path,
    signature: getKeySignature(),
  });
}

export async function interrupt(paramMyWorker?: SharedWorker) {
  const worker = paramMyWorker ?? myWorker;
  if (!worker) {
    return;
  }
  worker.port.postMessage({ action: "interrupt" });
}

export async function removeFile(fileId: string, paramMyWorker?: SharedWorker) {
  const worker = paramMyWorker ?? myWorker;
  if (!worker) {
    return;
  }
  worker.port.postMessage({ action: "removeFile", fileId });
}

export async function removeAllCompleted(paramMyWorker?: SharedWorker) {
  const worker = paramMyWorker ?? myWorker;
  if (!worker) {
    return;
  }
  worker.port.postMessage({ action: "removeAllCompleted" });
}

export async function removeAll(paramMyWorker?: SharedWorker) {
  const worker = paramMyWorker ?? myWorker;
  if (!worker) {
    return;
  }
  worker.port.postMessage({ action: "removeAll" });
}

export async function getFileList(paramMyWorker?: SharedWorker): Promise<void> {
  return new Promise((resolve) => {
    const worker = paramMyWorker ?? myWorker;
    if (!worker) {
      return;
    }
    worker.port.postMessage({ action: "getFileList" });
  });
}
*/
// switch back to false if
const simulateMissingSupport = false; // true - test
if (simulateMissingSupport) {
    window.Worker = undefined;
    window.BroadcastChannel = undefined;
}
function isMobileBrowser() {
    return typeof Worker === "undefined" || typeof BroadcastChannel === "undefined";
}
let myWorker = undefined;
let broadcast = undefined;
// Global cancellation flag - checked by broadcast handlers to ignore messages during cancel
let isCancellingUpload = false;
export function setIsCancellingUpload(value) {
    isCancellingUpload = value;
    console.log(`Upload cancellation flag set to: ${value}`);
}
export function getIsCancellingUpload() {
    return isCancellingUpload;
}
if (!isMobileBrowser() && typeof BroadcastChannel !== "undefined") {
    broadcast = new BroadcastChannel("upload-channel");
}
else {
    console.warn("BroadcastChannel is not supported in this browser.");
}
// Cache busting version - increment this when uploadWorker.js changes
const WORKER_VERSION = "20260112-v6";
export function initUploadWorker(onMessage) {
    if (isMobileBrowser() || typeof Worker === "undefined" || broadcast === undefined) {
        console.warn("Web Worker is not supported in this browser.");
        return undefined;
    }
    myWorker = new Worker(`/uploadWorker.js?v=${WORKER_VERSION}`);
    console.log("myWorker", myWorker);
    console.log("broadcast", broadcast);
    myWorker.onmessage = (e) => {
        if (onMessage) {
            onMessage(e.data);
        }
        else {
            console.log("Received from worker:", e.data);
        }
        // Re-broadcast to other tabs (if needed)
        broadcast.postMessage(e.data);
    };
    // Optional: Receive messages from other tabs
    broadcast.onmessage = (e) => {
        console.log("Broadcast received:", e.data);
        if (onMessage) {
            onMessage(e.data);
        }
    };
    return myWorker;
}
function postToWorker(message, paramMyWorker) {
    const worker = paramMyWorker ?? myWorker;
    if (!worker)
        return;
    console.log("message", message, paramMyWorker);
    worker.postMessage(message);
}
export async function start(paramMyWorker) {
    postToWorker({ action: "start" }, paramMyWorker);
}
export async function addFile(provider, file, path, onUploadProgress, onCompleted, onFinished, paramMyWorker) {
    console.log("belép");
    const pathParts = splitPath(path);
    if (pathParts?.name && pathParts.name.startsWith("~$")) {
        onFinished?.(undefined);
        return;
    }
    if (!isMobileBrowser() && broadcast) {
        broadcast.onmessage = (e) => {
            const data = e.data;
            console.log(data);
            // CRITICAL: Ignore completed/finished messages during cancel to prevent state corruption
            if (isCancellingUpload) {
                if (data.status === "completed" || data.status === "finished") {
                    console.log(`Ignoring ${data.status} message during cancel`);
                    return;
                }
            }
            if (data.status === "completed") {
                onCompleted?.(data);
            }
            else if (data.status === "uploading") {
                console.log("uploading", data);
                onUploadProgress?.(data);
            }
            else if (data.status === "finished") {
                onFinished?.(data);
            }
            else {
                console.log("Received message from broadcast:", data);
            }
        };
    }
    const baseUrl = process.env.DWINITY_BACKEND ?? "https://api.dev.dwinity.com";
    const filesUrl = baseUrl + `/api/${apiVersion}/files`;
    const authToken = await loadJwt();
    const sendObject = { path };
    const message = encodeSendObjectToBase58(sendObject);
    const fileId = crypto.randomUUID();
    if (!isMobileBrowser()) {
        postToWorker({
            action: "addFile",
            filesUrl,
            fileId,
            authToken,
            file,
            message,
            path,
            signature: getKeySignature(),
        }, paramMyWorker);
    }
    else {
        const signature = getKeySignature();
        syncUploadFile(filesUrl, file, message, path, signature, onUploadProgress, onCompleted, onFinished);
    }
}
export async function interrupt(paramMyWorker) {
    if (isMobileBrowser()) {
        abortSyncUpload();
    }
    else {
        postToWorker({ action: "interrupt" }, paramMyWorker);
    }
}
export async function removeFile(fileId, paramMyWorker) {
    postToWorker({ action: "removeFile", fileId }, paramMyWorker);
}
export async function removeAllCompleted(paramMyWorker) {
    postToWorker({ action: "removeAllCompleted" }, paramMyWorker);
}
export async function removeAll(paramMyWorker) {
    postToWorker({ action: "removeAll" }, paramMyWorker);
}
export async function getFileList(paramMyWorker) {
    return new Promise((resolve) => {
        postToWorker({ action: "getFileList" }, paramMyWorker);
        resolve();
    });
}
let uploadedFilePaths = new Set();
let uploadingFilePaths = new Set();
let activeUploads = new Map();
let createdRootFolders = new Set();
let plannedUploadPaths = new Set();
const UPLOAD_SESSION_KEY = "dwinity_upload_session";
const SESSION_MAX_AGE_MS = 24 * 60 * 60 * 1000; // 24 hours
let currentUploadSessionId = null;
function generateUploadSessionId() {
    return crypto.randomUUID();
}
// Maximum paths to save to localStorage (prevents quota exceeded errors)
// For large uploads (100k+ files), the orchestrator handles resume capability
const MAX_LOCALSTORAGE_PATHS = 10000;
function saveSessionToStorage(sessionId, paths) {
    // Skip localStorage for very large uploads - orchestrator handles resume
    if (paths.length > MAX_LOCALSTORAGE_PATHS) {
        console.log(`Skipping localStorage save: ${paths.length} paths exceeds limit of ${MAX_LOCALSTORAGE_PATHS}. Orchestrator will handle resume.`);
        return;
    }
    const sessionData = {
        sessionId,
        paths,
        timestamp: Date.now(),
    };
    try {
        localStorage.setItem(UPLOAD_SESSION_KEY, JSON.stringify(sessionData));
        console.log(`Saved upload session to localStorage: ${sessionId} with ${paths.length} paths`);
    }
    catch (error) {
        console.error("Failed to save upload session to localStorage:", error);
    }
}
function loadSessionFromStorage() {
    try {
        const data = localStorage.getItem(UPLOAD_SESSION_KEY);
        if (!data) {
            return null;
        }
        const parsed = JSON.parse(data);
        if (!parsed.sessionId || !Array.isArray(parsed.paths) || typeof parsed.timestamp !== "number") {
            console.warn("Invalid upload session data in localStorage");
            return null;
        }
        return parsed;
    }
    catch (error) {
        console.error("Failed to load upload session from localStorage:", error);
        return null;
    }
}
function isSessionValid(session) {
    const age = Date.now() - session.timestamp;
    if (age > SESSION_MAX_AGE_MS) {
        console.warn(`Upload session expired: ${age}ms old (max: ${SESSION_MAX_AGE_MS}ms)`);
        return false;
    }
    if (currentUploadSessionId && session.sessionId !== currentUploadSessionId) {
        console.warn(`Session ID mismatch: stored=${session.sessionId}, current=${currentUploadSessionId}`);
        return false;
    }
    return true;
}
function rehydrateSessionFromStorage() {
    const session = loadSessionFromStorage();
    if (session && isSessionValid(session)) {
        currentUploadSessionId = session.sessionId;
        plannedUploadPaths = new Set(session.paths);
        console.log(`Rehydrated upload session from localStorage: ${session.sessionId} with ${session.paths.length} paths`);
    }
}
rehydrateSessionFromStorage();
export function getSessionManifest() {
    const session = loadSessionFromStorage();
    if (!session) {
        console.log("No upload session found in localStorage");
        return null;
    }
    if (!isSessionValid(session)) {
        console.log("Upload session is invalid or expired");
        clearUploadSession();
        return null;
    }
    console.log(`Retrieved valid session manifest: ${session.paths.length} paths, session=${session.sessionId}`);
    return session.paths;
}
export function clearUploadSession() {
    try {
        localStorage.removeItem(UPLOAD_SESSION_KEY);
        console.log("Cleared upload session from localStorage");
    }
    catch (error) {
        console.error("Failed to clear upload session from localStorage:", error);
    }
    currentUploadSessionId = null;
    plannedUploadPaths.clear();
}
function extractRootFolder(path) {
    const parts = path.split("/").filter(Boolean);
    if (parts.length >= 1) {
        return "/" + parts[0];
    }
    return null;
}
export function setPlannedUploadPaths(paths) {
    plannedUploadPaths.clear();
    createdRootFolders.clear();
    uploadingFilePaths.clear();
    activeUploads.clear();
    currentUploadSessionId = generateUploadSessionId();
    for (const path of paths) {
        plannedUploadPaths.add(path);
        const rootFolder = extractRootFolder(path);
        if (rootFolder) {
            createdRootFolders.add(rootFolder);
        }
    }
    saveSessionToStorage(currentUploadSessionId, [...plannedUploadPaths]);
    console.log(`Planned upload manifest set: ${plannedUploadPaths.size} files, ${createdRootFolders.size} root folders, session=${currentUploadSessionId}`);
}
const PATH_CHUNK_SIZE = 1000;
export async function setPlannedUploadPathsAsync(paths) {
    plannedUploadPaths.clear();
    createdRootFolders.clear();
    uploadingFilePaths.clear();
    activeUploads.clear();
    currentUploadSessionId = generateUploadSessionId();
    const total = paths.length;
    for (let i = 0; i < total; i += PATH_CHUNK_SIZE) {
        const chunk = paths.slice(i, i + PATH_CHUNK_SIZE);
        for (const path of chunk) {
            plannedUploadPaths.add(path);
            const rootFolder = extractRootFolder(path);
            if (rootFolder) {
                createdRootFolders.add(rootFolder);
            }
        }
        if (i + PATH_CHUNK_SIZE < total) {
            await new Promise(resolve => setTimeout(resolve, 0));
        }
    }
    saveSessionToStorage(currentUploadSessionId, [...plannedUploadPaths]);
    console.log(`Planned upload manifest set (async): ${plannedUploadPaths.size} files, ${createdRootFolders.size} root folders, session=${currentUploadSessionId}`);
}
export function getPlannedUploadPaths() {
    return [...plannedUploadPaths];
}
export function addPlannedUploadPaths(paths) {
    for (const path of paths) {
        plannedUploadPaths.add(path);
        const rootFolder = extractRootFolder(path);
        if (rootFolder) {
            createdRootFolders.add(rootFolder);
        }
    }
    if (currentUploadSessionId) {
        saveSessionToStorage(currentUploadSessionId, [...plannedUploadPaths]);
    }
    console.log(`Added ${paths.length} paths to manifest (total: ${plannedUploadPaths.size})`);
}
export function getCurrentUploadSessionId() {
    return currentUploadSessionId;
}
export function trackUploadingFile(path) {
    if (!uploadingFilePaths.has(path)) {
        uploadingFilePaths.add(path);
        const rootFolder = extractRootFolder(path);
        if (rootFolder) {
            createdRootFolders.add(rootFolder);
        }
        console.log(`Tracking uploading file: ${path} (uploading: ${uploadingFilePaths.size}, roots: ${createdRootFolders.size})`);
    }
}
export function registerActiveUpload(path, uploadId, filesUrl) {
    activeUploads.set(path, { uploadId, filesUrl });
    console.log(`Registered active upload: ${path} -> ${uploadId}`);
}
export function unregisterActiveUpload(path) {
    activeUploads.delete(path);
    console.log(`Unregistered active upload: ${path}`);
}
export function getActiveUploads() {
    return new Map(activeUploads);
}
export function trackUploadedFile(path) {
    uploadingFilePaths.delete(path);
    activeUploads.delete(path);
    if (!uploadedFilePaths.has(path)) {
        uploadedFilePaths.add(path);
        console.log(`Tracked completed file: ${path} (completed: ${uploadedFilePaths.size})`);
    }
}
export function getUploadedFilePaths() {
    return [...uploadedFilePaths];
}
export function getAllTrackedFiles() {
    return [...new Set([...uploadedFilePaths, ...uploadingFilePaths])];
}
export function resetUploadState() {
    uploadedFilePaths = new Set();
    uploadingFilePaths = new Set();
    activeUploads = new Map();
    createdRootFolders = new Set();
    // CRITICAL: Do NOT clear plannedUploadPaths here!
    // It must survive until deleteUploadedFilesOnCancel() consumes it
    console.log("Upload state reset - ready for new upload from File 1");
}
/** @deprecated Use clearUploadSession() instead */
export function clearPlannedUploadPaths() {
    clearUploadSession();
}
export function getCreatedRootFolders() {
    return [...createdRootFolders];
}
async function deleteFileWithRetry(authToken, path, maxRetries = 5) {
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
            await myRemoveFileJwt(authToken, path);
            return true;
        }
        catch (error) {
            console.warn(`Delete attempt ${attempt}/${maxRetries} failed for ${path}:`, error);
            if (attempt < maxRetries) {
                const delay = attempt * 2000;
                console.log(`Waiting ${delay}ms before retry...`);
                await new Promise(resolve => setTimeout(resolve, delay));
            }
        }
    }
    return false;
}
function getUniqueFolders(paths) {
    const folders = new Set();
    for (const path of paths) {
        const parts = path.split("/").filter(Boolean);
        if (parts.length > 1) {
            const folderPath = "/" + parts.slice(0, -1).join("/");
            folders.add(folderPath);
        }
    }
    return Array.from(folders).sort((a, b) => b.length - a.length);
}
export async function deleteUploadedFilesOnCancel(onProgress, preSnapshotPaths) {
    const actuallyUploadedPaths = getUploadedFilePaths();
    const confirmedPaths = new Set([...actuallyUploadedPaths, ...(preSnapshotPaths || [])]);
    console.log(`Cancel cleanup: ${actuallyUploadedPaths.length} tracked as uploaded, ${preSnapshotPaths?.length || 0} from snapshot`);
    if (confirmedPaths.size === 0) {
        console.log("No files were actually uploaded - nothing to delete from server");
        clearUploadSession();
        uploadedFilePaths = new Set();
        uploadingFilePaths = new Set();
        activeUploads = new Map();
        createdRootFolders = new Set();
        return { deleted: 0, failed: 0, aborted: 0, foldersDeleted: 0, successfulPaths: [] };
    }
    const pathsToDelete = Array.from(confirmedPaths);
    console.log(`Cancel cleanup: ${pathsToDelete.length} actually uploaded files to delete`);
    const computedRootFolders = new Set();
    for (const path of pathsToDelete) {
        const root = extractRootFolder(path);
        if (root) {
            computedRootFolders.add(root);
        }
    }
    const rootFolders = Array.from(computedRootFolders);
    console.log(`Cancel cleanup: ${pathsToDelete.length} paths to delete, ${rootFolders.length} root folders: [${rootFolders.join(", ")}]`);
    let deleted = 0;
    let failed = 0;
    let foldersDeleted = 0;
    const successfullyDeletedPaths = [];
    const authToken = await loadJwt();
    if (!authToken) {
        console.error("No auth token available for file deletion");
        clearUploadSession();
        return { deleted: 0, failed: 0, aborted: 0, foldersDeleted: 0, successfulPaths: [] };
    }
    for (let i = 0; i < pathsToDelete.length; i++) {
        const path = pathsToDelete[i];
        if (onProgress) {
            onProgress(i + 1, pathsToDelete.length, path, "deleting");
        }
        const success = await deleteFileWithRetry(authToken, path);
        if (success) {
            deleted++;
            successfullyDeletedPaths.push(path);
            console.log(`Deleted: ${path}`);
        }
        else {
            failed++;
            console.error(`Failed to delete: ${path}`);
        }
    }
    const folders = getUniqueFolders(pathsToDelete);
    for (const folder of folders) {
        if (onProgress) {
            onProgress(1, 1, folder, "cleaning folders");
        }
        try {
            await myRemoveFileJwt(authToken, folder);
            foldersDeleted++;
            console.log(`Deleted folder: ${folder}`);
        }
        catch (error) {
            console.log(`Folder not empty or already deleted: ${folder}`);
        }
    }
    for (const rootFolder of rootFolders) {
        try {
            await myRemoveFileJwt(authToken, rootFolder);
            foldersDeleted++;
            console.log(`Deleted root folder: ${rootFolder}`);
        }
        catch (error) {
            console.log(`Root folder not empty or already deleted: ${rootFolder}`);
        }
    }
    console.log(`Cancel cleanup complete: ${deleted} deleted, ${failed} failed, ${foldersDeleted} folders`);
    uploadedFilePaths = new Set();
    uploadingFilePaths = new Set();
    activeUploads = new Map();
    createdRootFolders = new Set();
    clearUploadSession();
    console.log("Cleared planned upload manifest after cancel cleanup");
    return { deleted, failed, aborted: 0, foldersDeleted, successfulPaths: successfullyDeletedPaths };
}
